/* import store from '@/store'; // Importiere den Vuex-Store

export function getXmlValueByPath(xpath) {
    if (!store.state.xmlFile) return 'no data';
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(store.state.xmlFile, 'application/xml'); // Hier wird das XML korrekt geparst
    const result = xmlDoc.evaluate(xpath, xmlDoc, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
    return result.singleNodeValue ? result.singleNodeValue.textContent : null;
} */

// getXmlValueByPath.js
import axios from 'axios';
import store from '@/store'; // oder wo immer dein Vuex-Store liegt

export async function getXmlValueByPath(xpath) {
  if (!store.state.xmlFile) return 'no data'
  try {
    const response = await axios.post('https://html-creator.demo.cartago.com/api/xml/evaluateDynamic', 
    {
      xml: store.state.xmlFile,
      xpath
    },
    {
        headers: {
        'Content-Type': 'application/json',
      },
    }
);
    // Der Backend-Endpunkt liefert z.B. { result: "Ergebnis-String" }
    return response.data.result;
  } catch (error) {
    console.error('Fehler beim Abrufen der XML-Daten:', error);
    return null;
  }
}
